// extracted by mini-css-extract-plugin
module.exports = {"block":"Collapse_block__3M468","icon":"Collapse_icon__2E8mj"};